import Api from '@/api'


const fetchAll = () => {	
    return Api.get('api/tagcategories')
};

const postForm =  (payload,id) => {  
    
    if(typeof id != "undefined") { 
        
        return Api.put('api/tagcategories/' + id , payload)       
    } else {
        return Api.post('api/tagcategories' , payload)       
    }
    
};

const getById =  (payload) => {        
    return Api.get('api/tagcategories/' + payload)       
};

const deleteById =  (payload) => {        
    return Api.delete('api/tagcategories/'+payload)
    
};

export default {
  fetchAll,
  postForm,
  getById,
  deleteById
};